module.exports = __webpack_public_path__ + "static/media/NP.260ac001.svg";